export const maxFileSize = 10000000;
